import { render, staticRenderFns } from "./StockKLine5MinView.vue?vue&type=template&id=610c37df&scoped=true"
import script from "./StockKLine5MinView.vue?vue&type=script&lang=js"
export * from "./StockKLine5MinView.vue?vue&type=script&lang=js"
import style0 from "./StockKLine5MinView.vue?vue&type=style&index=0&id=610c37df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c37df",
  null
  
)

export default component.exports